import { v4 } from 'uuid';

const tagColors = [
  '#700303',
  '#993300',
  '#B7202F',
  '#E80505',
  '#FF0000',
  '#FF6600',
  '#FF9900',
  '#FFCC99',
  '#FFCC00',
  '#FFFF00',
  '#FFFF99',
  '#00FF00',
  '#008000',
  '#339966',
  '#CCFFCC',
  '#99CC00',
  '#808000',
  '#D3D3D3',
  '#183319',
  '#008080',
  '#33CCCC',
  '#CCFFFF',
  '#00CCFF',
  '#00FFFF',
  '#99CCFF',
  '#256FEB',
  '#3366FF',
  '#0000FF',
  '#1A3E94',
  '#003366',
  '#000080',
  '#333399',
  '#666699',
  '#CC99FF',
  '#800080',
  '#993366',
  '#FF00FF',
  '#FF99CC',
  '#D6D6D6',
  '#B7B7B7',
  '#808080',
  '#333333',
  '#000000',
  '#FFFFFF',
];

const fakeTagNames = [
  'Amazon Orders',
  "Don't ship this today",
  "Please don't include promotional material to this order",
  'The reason that carriers are different than providers comes from a long time ago where godzilla ran into a bus.',
  'Ship this stuff TODAY',
  'Urgent Order',
  'What in Tagnation?',
  "Papa's got a brand new Tag",
];

const getRandomArrayValue = (array) => {
  const randomIndex = Math.round(Math.random() * 1000) % array.length;
  return array[randomIndex];
};

class TagServiceClass {
  getTagColors() {
    return tagColors;
  }

  getRandomTagColor(includeWhite = true) {
    if (includeWhite) {
      return getRandomArrayValue(tagColors);
    }
    return getRandomArrayValue(tagColors.filter((color) => color !== '#FFFFFF'));
  }

  getRandomFakeTagName() {
    return getRandomArrayValue(fakeTagNames);
  }

  getFakeTag() {
    return {
      name: this.getRandomFakeTagName(),
      hexColor: this.getRandomTagColor(),
      id: v4(),
    };
  }

  getFakeTags(numberOfTags) {
    const tags = [];
    for (let x = 0; x < numberOfTags; x++) {
      tags.push({ ...this.getFakeTag(), tagId: `tag-${x}` });
    }
    return tags;
  }
}

export const TagService = new TagServiceClass();
